import { cn } from "../../../lib/utils";
import { lpConfig } from "../lpConfig";
import { useFadeIn } from "../useFadeIn";

/**
 * 導入企業の声（事例・テスティモニアル）セクション
 * 3社の導入事例をカード形式で表示し、成果バッジ・引用・企業情報を含む
 * @return {JSX.Element} テスティモニアルセクションコンポーネント
 */
export function LpTestimonials() {
  const { ref, isVisible } = useFadeIn();

  return (
    <section id="testimonials" className="py-24 lg:py-32 bg-white">
      <div
        ref={ref}
        className={cn(
          "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lp-fade-in-up",
          isVisible && "lp-visible",
        )}
      >
        <div className="text-center">
          <p className="text-xs font-bold tracking-widest text-[#ff8d00] uppercase mb-4">
            {lpConfig.testimonials.sectionLabel}
          </p>
          <h2 className="text-4xl font-bold text-[#0F1649] mb-16">
            {lpConfig.testimonials.heading}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {lpConfig.testimonials.items.map(testimonial => (
            <div
              key={testimonial.company}
              className="p-8 rounded-2xl border border-gray-100 bg-gray-50/50"
            >
              <span className="inline-flex px-4 py-2 rounded-full bg-[#30BF78]/10 text-[#30BF78] font-bold text-sm mb-4">
                {testimonial.result}
              </span>
              <p className="text-gray-600 mb-6 leading-relaxed italic">
                「{testimonial.quote}」
              </p>
              <p className="text-sm font-bold text-[#0F1649]">
                {testimonial.company}
              </p>
              <p className="text-sm text-gray-400">{testimonial.person}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
